var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed top-0 left-0 bottom-0 right-0 flex justify-center items-center px-6 text-black-100 z-50",staticStyle:{"background-color":"rgba(255,255,255,0.5)"}},[_c('div',{staticClass:"z-10 w-10 animate-spin"},[_c('img',{attrs:{"src":"/img/wizard/progress.png"}})])])
}]

export { render, staticRenderFns }